/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_updateEmailCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        $scope.success = function (msg) {
            Notification.success(msg);
        };
        $scope.error = function (msg) {
            Notification.error(msg);
        };

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        $scope.updateEmail = function ()
        {

            var oldEmail = MainService.getDialogData("dialog_updateEmailCtrl")["email"]
            if (validateEmail($scope.newEmail))
            {
                NetworkService.updateEmail(oldEmail, $scope.newEmail, function (data) {
                    if (data.done)
                    {
                        $scope.success("Bitte schau in deinen E-Mails nach, und klick dort auf den Bestätigungslink")
                    } else
                    {
                        $scope.error("Es gab einen Fehler")
                    }
                })
            }
            else
            {
                $scope.error("Die Email Adresse ist ungültig")
            }


        }


    }])